<template lang="pug">
  #Label
    appHeader
    router-view.content-body-hasFooter
    appSmFooter
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import appSmFooter from '@/components/partials/AppSmFooter.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'LabelComponent',
  components: {
    appHeader,
    appSmFooter
  }
};
</script>
